import { BaseRecord } from "./BaseRecord";
import { Business } from "./Business";
import { City } from "./City";
import { Country } from "./Country";
import { State } from "./State";

export class Address extends BaseRecord<number> {
    public addressLine1!: string;
    public addressLine2!: string;
    public landmark!: string;
    public pinCode !: string;

    public countryId!: number;
    public country!: Country | null;

    public stateId!: number;
    public state!: State | null;

    public cityId!: number;
    public city!: City | null;

    public businessId!: number;
    public business!: Business | null;

    constructor() {
        super();
        this.id = 0;
        this.addressLine1 = "";
        this.addressLine2 = "";
        this.landmark = "";
        this.pinCode = "";

        this.countryId = 0;
        this.country = new Country();

        this.stateId = 0;
        this.state = new State();

        this.cityId = 0;
        this.city = new City();

        this.businessId = 0;
        this.business = new Business();
    }
}
